import React, { useState } from "react";

// NOTE(kjellski): Don't rename the Keys, they're used for translation
export enum AdditionalChainLinks {
  NoLinks = 0,
  TenLinks = 2,
  ElevenLinks = 4,
  TwelveLinks = 6,
  ThirteenLinks = 8,
  FourteenLinks = 10,
  FifteenLinks = 12,
}

const MinKs = 350;
const MaxKs = 450;
const MinZk = 25;
const MaxZk = 65;
const MinZr = 15;
const MaxZr = 35;

export const useChainLengthCalculator = () => {
  /**
  Auswahlmöglichkeiten für die Angaben im Rechner:
  KS = Kettenstrebenlänge | zwischen 350 und 450 mm (Intervalle: 1mm)
  ZK = Anzahl Zähne des größten Kettenblatts (vorne) | zwischen 25 und 65 (Intervall: 1)
  ZR = Anzahl Zähne des größten Ritzels (hinten) | zwischen 15 und 35 (Intervall: 1)
  Z = Zusätzliche Kettenglieder | zwischen 10 bis 15 (Intervall: 1) und „kein Röllchen“
      bei Röllchen mit 10 Zähnen: Z = 2,
                  bei 11 Zähnen: Z = 4,
                  bei 12 Zähnen: Z = 6,
                  bei 13 Zähnen: Z = 8,
                  bei 14 Zähnen: Z = 10
                  bei 15 Zähnen: Z = 12
                  ohne Röllchen: Z = 0
  KL = Kettenlänge (Gliedanzahl)
  L  = Länge in cm

  Formel:
  KL = 0,157 * KS + 1/2 * ZK + 1/2 * ZR + Z
  L  = KL * 1,27 cm
 */

  const [ks, setKs] = useState(400);
  const [zk, setZk] = useState(45);
  const [zr, setZr] = useState(25);
  const [z, setZ] = useState(0);

  const kl = Math.ceil(0.157 * ks + (1 / 2) * zk + (1 / 2) * zr + z);
  const l = Math.ceil(kl * 1.27);

  return {
    MinKs,
    MaxKs,
    ks,
    setKs,
    MinZk,
    MaxZk,
    zk,
    setZk,
    MinZr,
    MaxZr,
    zr,
    setZr,
    z,
    setZ,
    kl,
    l,
  };
};
